/**
 * 找样列表
 * */
import React from 'react'
import Lang from '@components/Lang/Lang'
import { Select,Spin,Button} from "antd";
import {getIntlYYMMDD,isEmpty,isEmptyObject,trim,getFileSuffix,symbolMoneyUtil} from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import { Link } from "react-router-dom";
import { toFixedWithCommas} from "@utils/number-util";
import ReleaseFuzzy from "../components/ReleaseFuzzy";
import LazyLoad from "react-lazyload";
import dayjs from 'dayjs';
import "./index.less"
const { Option } = Select;
export default class TakeDelivery extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            // 搜索 表单 配置
            searchFormOptions:[
                {
                    name:'createBy',
                    cnPlaceholder:'请选择登记人',
                    cnPlaceholderId:'QingXuanZeDengJiRen',
                    hiddenLabel: true,
                    width: 190,
                    type:"SearchSelect",
                    searchClass:{
                        api:"/service/mg/fuzzy/create-user-list",
                    },
                },
                {
                    name:'keyword',
                    cnPlaceholder:'搜索客户名称/编号/联系电话',
                    cnPlaceholderId:'SouSuoKeHuMingChengBianHa',
                    width:216,
                },
            ],
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    getStatusHtml(item){
        if(item.status=='15'){
            return <div className="statusLabel statusLabel15">
                {Lang({id:"ZhaoYangZhong",default:"找样中"})}
            </div>
        }else if(item.status=='20'){
            return <div className="statusLabel statusLabel20">
                {Lang({id:"YouZhaoDao",default:"有找到"})}
            </div>
        }else if(item.status=='50'){
            return <div className="statusLabel statusLabel50">
                {Lang({id:"RenWuWanCheng",default:"任务完结"})}
            </div>
        }else if(item.status=='40'){
            return <div className="statusLabel statusLabel40">
                {Lang({id:"YiQuXiao",default:"已取消"})}
            </div>
        }
        return null;
    }

    getTipHtml(item){
        if(item.status=='15'){
            return <div className="color045 font_14 lineH_150p mt_4">{Lang({id:"PinLeiJingLiZhengZaiWeiNi",default:"品类经理正在为你找样中"})}</div>
        }else if(item.status=='20'){
            return <div >
                {
                    item.isNew?
                        <i className="red-dot"></i>
                        :
                        null
                }
                <span className="color066 font_14 lineH_150p">
                    {Lang({id:"YouGengXinGongZhaoDaoKuan",default:"{0} 有更新，共找到 {1} 款",params:[item.newReplyTime?dayjs(item.newReplyTime).format('MM-DD'):'-',item.skuNum]})}
                </span>
            </div>
        }else if(item.status=='50'){
            if(item.skuNum>0){
                return <div className="flex-box">
                    <img className="emoji" src="https://oss.essaone.com/f267ccb0-d014-479b-a6a3-da6c6761fcb3.png" alt=""/>
                    <span className="color066 font_14 lineH_150p">
                        {Lang({id:"YiQuanBuZhaoWanGongZhaoDa",default:"YiQuanBuZhaoWanGongZhaoDa",params:[item.effectiveEndTime?dayjs(item.effectiveEndTime).format('MM-DD'):'-',item.skuNum]})}
                    </span>
                </div>
            }else{
                return (<div className="color066 font_14 lineH_150p">
                    {Lang({id:"BaoQianWoMenMeiYouZhaoDao",default:"抱歉，我们没有找到合适的商品"})}
                </div>)
            }
        }else if(item.status=='40'){
            return (<div className="color045 font_14 lineH_150p">
                {item.lastUpdateTime?dayjs(item.lastUpdateTime).format('MM-DD'):'-'}
                <span className={"mr_4"}>{Lang({id:"QuXiao",default:"取消"})}</span>
            </div>);
        }else{
            return null;
        }
    }

    /**
     * 列表
     * item 数据
     * index
     * */
    renderList=(item={},index,)=>{
        let file = {};
        if(item.fileList&&item.fileList.length>0){
            file = item.fileList[0];
        }
        const buyerVO= item.buyerVO||{};
        return (<Link  key={'list_'+index} className="link" to={`/customer/fuzzy-detail?id=${item.id}&&source=sampleList`}>
            <div className="samItem font_14 black89 lineH_150p" >
                {file.url?<LazyLoad height={80} offset={0}>
                            <img src={file.url} className="img" alt=""/>
                        </LazyLoad>:<img src="http://oss.essa.cn/04d1ca90-811f-4d61-96d4-ada86e4bfedb.svg" className="img" alt=""/>}
                <div className="flex-1">
                    {item.subject?<div className="content mb_4" title={item.subject}>{item.subject}</div>:null}
                    <div className={"fw_500 mb_4"}>{buyerVO.code||"-"} {buyerVO.countryName||"-"}</div>
                    {
                        item.isNewMessage?
                            <div className="color_FB7321 mb_4 font_14">
                                {Lang({id:"ShangPinJingLiHuiFuLeXinD",default:"商品经理回复了新的消息"})}
                            </div>:null
                    }
                    <div className="flex-item-ver-center">
                        {this.getStatusHtml(item)}
                        {this.getTipHtml(item)}
                    </div>
                </div>
                <div className="ml_60 text-right no-wrap">
                    <div className="black66">
                        {item.createTime?getIntlYYMMDD(item.createTime):""}
                    </div>
                    <div className="black33 font_12">#{item.id}</div>
                    <div className={"black66"}>{Lang({id:"DengJiRen",default:"登记人"})}：{item.createByUserName||"-"}</div>
                </div>
            </div>
            </Link>)
    }
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    // 查询回调
    fetchCallBack(res={}){

    }
    getData(){
        this.onRefAutoFetchListChrld.handleFetch(1,true)
    }
    render() {
        const {loading, searchFormOptions, } = this.state;
        return (<Spin spinning={loading}>
                    <PageCommon>
                <CommonBreadcrumb list={[
                    {name: Lang({id: 'KeHuDeZhaoYang', default: '客户的找样'})},
                ]}></CommonBreadcrumb>
                 <div className={"mb_12"}>
                     <span className={"fw_700 font_16 black100 mr_12"}>{Lang({id:"KeHuZhaoYang",default:"客户找样"})}</span>
                     <ReleaseFuzzy type={40}
                                   showBuyerInput={true}
                                   callback={()=>this.getData(1)}>
                         <Button type={'primary'}>{Lang({id: 'FaQiZhaoYang', default: '发起找样'})}</Button>
                     </ReleaseFuzzy>
                 </div>
                <div className="sampleListPage">
                    <AutoFetchList onRef={this.onRefAutoFetchList}
                                   fetchCallBack={(data)=>this.fetchCallBack(data)}
                                   searchFormOptions={searchFormOptions}
                                   fetchApi={'/service/mg/fuzzy/list-by-mg'}
                                   renderList={(item,inx)=>this.renderList(item,inx)}  />
                </div>
            </PageCommon>
      </Spin>)
    }
}

